export function formatFileSize(bytes: number, decimals = 2) {
    if (!bytes) {
        return '0 Б';
    }

    const k = 1000;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб', 'Эб', 'Зб', 'Иб'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
